import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import webRecharge from '@utils/webrecharge';
import webConvertAndCash from '@utils/webConvertAndCash';
import util from '@utils/util';
import webLogin from '@utils/weblogin';
import loginReg from '../../login-reg/src/wrap';
import rightMenu from './rightmenu';
import NftWallets from '../../nft-wallets';
export default {
  name: 'globalHeader',
  data: function data() {
    return {
      isJmt: false,
      // 姐妹淘
      userInfo: null,
      status: false,
      logoutDisplay: true,
      userFace: '',
      countryCode: '',
      showHeader: false,
      islogined: false,
      closeState: true,
      scrollY: 0
    };
  },
  components: {
    rightMenu: rightMenu,
    loginReg: loginReg,
    NftWallets: NftWallets
  },
  computed: {
    leaveTop: function leaveTop() {
      return this.scrollY > 0;
    },
    /**
     * 获取当前的状态 默认是home
     */
    getCurrentStatus: function getCurrentStatus() {
      var defauleClass = ['home', 'explore', 'personal'];
      var hrefStr = window.location.href || '';
      // eslint-disable-next-line no-plusplus
      for (var i = 0, l = defauleClass.length; i < l; i++) {
        // eslint-disable-next-line no-useless-escape
        var re = new RegExp("/".concat(defauleClass[i], ".html"));
        if (hrefStr.match(re)) {
          return defauleClass[i];
        }
      }
      return 'home'; // default value
    }
  },
  methods: {
    KEWLSensorTrack: function KEWLSensorTrack(pathname) {
      util.KEWLSensorTrack({
        lmweb_clickText: '跳转',
        lmweb_tabName: pathname
      });
    },
    /**
     * 展示推出登陆
     */
    showLogout: function showLogout() {
      this.logoutDisplay = false;
    },
    hideLogout: function hideLogout() {
      this.logoutDisplay = true;
    },
    /**
     * 退出登陆
     */
    logoutAction: function logoutAction() {
      this.$refs.logReg.logoutAction();
      this.userInfo = null;
      this.islogined = false;
      this.logoutDisplay = true;
    },
    /**
     * 弹出登陆层
     */
    doLogin: function doLogin() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.$refs.logReg.showFrame();
      util.KEWLSensorTrack({
        lmweb_clickText: '唤起登陆'
      });
    },
    /**
     * 弹出登陆层
     */
    doReg: function doReg() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.$refs.logReg.showFrame();
      util.KEWLSensorTrack({
        lmweb_clickText: '唤起登陆'
      });
    },
    /**
     * 获取当前用户的头像
     */
    getLoginUserFace: function getLoginUserFace() {
      if (webLogin.checkLogin()) {
        var backgroundUrl = webLogin.getUserInfo().face;
        this.userFace = "background-image:url(".concat(backgroundUrl, ")");
      }
    },
    /**
     * 切换其他菜单
     */
    changeMenu: function changeMenu(state) {
      this.closeState = state;
    },
    // 带参传递
    getHeaderLink: function getHeaderLink(pathname) {
      var local = util.getI18nLocale();
      local = pathname == '/' ? '' : local;
      // 带参传递
      var json = {
        pathname: "/".concat(local).concat(pathname == '/' ? '' : pathname),
        search: {}
      };
      return util.directToPath(json, true);
    },
    /**
     * 跳转 其他页面
     */
    doRecharge: function doRecharge() {
      webRecharge.doRecharge();
    },
    /**
     * 跳转 其他页面
     */
    doConvert: function doConvert() {
      webConvertAndCash.doConvert();
    },
    /**
     * 跳转 其他页面
     */
    doCashOut: function doCashOut() {
      webConvertAndCash.doCashOut();
    },
    /**
     * 推出登陆
     */
    logoutHandle: function logoutHandle() {
      this.userInfo = null;
      this.islogined = false;
      this.$lmBus && this.$lmBus.$emit('Live-Login-Out-Handle');
    },
    /**
     * 登陆成功
     */
    successHandle: function successHandle(data) {
      this.userInfo = data;
      this.islogined = true;
      this.$refs.logReg.closeFrame();
      this.getLoginUserFace();
      this.$lmBus && this.$lmBus.$emit('Live-Login-Success-Handle', data);
    }
  },
  created: function created() {
    var _this = this;
    this.$lmBus && this.$lmBus.$on('Header-Login-Success-Handle', function (data) {
      if (data) {
        _this.userInfo = data;
        _this.islogined = true;
        _this.getLoginUserFace();
      }
    });
    this.$lmBus && this.$lmBus.$on('Header-Login-Out-Handle', function () {
      _this.userInfo = null;
      _this.islogined = false;
    });
    this.$lmBus && this.$lmBus.$on('Header-Login-Pop-Handle', function (type) {
      if (type === 'login') {
        _this.doLogin();
      } else {
        _this.doReg();
      }
    });
  },
  beforeMount: function beforeMount() {
    var self = this;
    window && window.addEventListener('scroll', function () {
      self.scrollY = window.scrollY;
    });
  },
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.showHeader = true;
            _context.next = 3;
            return util.getI18nCountryCode(_this2.$route && _this2.$route.params.countryCode);
          case 3:
            _this2.countryCode = _context.sent;
            _this2.islogined = webLogin.checkLogin();
            _this2.userInfo = webLogin.getUserInfo();
            _this2.getLoginUserFace();
            /**
             * 当然国家码是台湾并且来源是姐妹淘，  就展示姐妹淘logo
             */
            if (util.isJMT(_this2.countryCode)) {
              _this2.isJmt = true;
            }
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};